import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        photoField: {
            width: '70%',
            margin: 'auto',
        },
        photoFieldCardMedia: {
            width: 120,
        },
        photoFieldAdd: {
            fontSize: '4rem',
        },
        photoEdit: {
            marginTop: theme.spacing(1),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        photoDelete: {
            marginTop: theme.spacing(1),
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        sectionTitle: {
            fontSize: '1.2rem',
            padding: theme.spacing(2),
            textAlign: 'center',
        },
        sectionTitleContainer: {
            position: 'relative',
            height: '6rem',
            backgroundColor: '#F0F0F0',
            padding: theme.spacing(2, 4, 2, 2),
            borderBottomWidth: 1,
            borderBottomColor: theme.palette.border.main,
            borderBottomStyle: 'solid',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        sectionTitleAddon: {
            'position': 'absolute',
            'top': 0,
            'right': 0,
            '& .MuiButtonBase-root': {
                marginTop: theme.spacing(-1),
                marginRight: theme.spacing(1),
                padding: theme.spacing(1),
                borderWidth: 1,
                borderStyle: 'solid',
                borderColor: theme.palette.secondary.main,
                borderRadius: theme.spacing(0.5),
            },
        },
        sectionTitleNumber: {
            position: 'absolute',
            top: 0,
            left: 0,
            padding: theme.spacing(1),
            borderBottomRightRadius: theme.spacing(0.5),
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
        },
        sectionHidden: {
            background:
                'repeating-linear-gradient(\n' +
                '    -55deg,\n' +
                '    #222,\n' +
                '    #222 10px,\n' +
                '    #333 10px,\n' +
                '    #333 20px\n' +
                '  )',
        },
        hidden: {
            display: 'none',
        },
        disabled: {
            '& .MuiInput-input': {
                opacity: 0,
            },
        },
        dragged: {
            opacity: 0.5,
        },
        over: {
            backgroundColor: theme.palette.text.primary,
        },
    }),
)
